export var ChartType;
(function (ChartType) {
    ChartType["Bar"] = "bar";
    ChartType["Line"] = "line";
    ChartType["Pie"] = "pie";
    ChartType["Doughnut"] = "doughnut";
    ChartType["PolarArea"] = "polar-area";
    ChartType["ScatterPlot"] = "scatter-plot";
    ChartType["Mixed"] = "mixed";
})(ChartType || (ChartType = {}));
